module.exports = "<div class=\"olyStickyHeaderWithText fix-touch-scrolling\" ng-click=\"redirectBack()\" ng-if=\"redirectTo\">\r\n    <a href=\"javascript://\">{{title}}</a>\r\n</div>\r\n\r\n<div class=\"olyStickyHeaderWithText fix-touch-scrolling\" ng-if=\"!redirectTo\">\r\n    <div class=\"olyStickyHeaderWithText-title\">{{title}}</div>\r\n    <wow-loading-spinner class=\"searchCountSpinner\" ng-if=\"loading\"></wow-loading-spinner>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/common/components/sticky-header/sticky-header-with-text-template.html
 ** module id = 857
 ** module chunks = 2
 **/